import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { alignSelf, flex, order, } from 'styled-system';
import asRendition from '../../asRendition';
export var Box = asRendition(styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\tbox-sizing: border-box;\n\t\t", ";\n\t\t", ";\n\t\t", ";\n\t"], ["\n\t\tbox-sizing: border-box;\n\t\t", ";\n\t\t", ";\n\t\t", ";\n\t"])), flex, order, alignSelf));
Box.displayName = 'Box';
var templateObject_1;
